'use strict';

(function () {
  'use strict';

  angular.module('vnext').config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('vnext.content.browse', {
      url: 'browse',
      abstract: true,
      default: '.categories',
      template: '<ui-view />',
      resolve: {
        categories: ['searchPageSvc', function (searchPageSvc) {
          return searchPageSvc.getCategories();
        }],
        appMode: ['userSvc', function (userSvc) {
          return userSvc.getUser().then(function (user) {
            return user && user.accessCode && user.accessCode.applicationMode ? user.accessCode.applicationMode.name : 'STANDARD';
          });
        }]
      },
      data: {
        pageTitle: 'pageTitles.browse'
      }
    }).state('vnext.content.browse.categories', {
      url: '',
      templateUrl: 'vnext/pages/browse/browse.html',
      controller: 'BrowseCtrl',
      controllerAs: 'vm'
    }).state('vnext.content.browse.searchresults', {
      url: '/results/:query?type&size&from',
      params: {
        data: null
      },
      templateUrl: 'vnext/pages/browse/searchResults.html',
      controller: 'SearchResultsCtrl',
      controllerAs: 'vm',
      data: {
        pageTitle: 'pageTitles.search'
      }
    }).state('vnext.content.browse.page', {
      url: '/{pageId:int}',
      abstract: true,
      default: '.view',
      template: '<div ui-view></div>',
      resolve: {
        page: ['$stateParams', 'categories', 'searchPageSvc', function ($stateParams, categories, searchPageSvc) {
          return searchPageSvc.findPage($stateParams.pageId, categories);
        }]
      }
    }).state('vnext.content.browse.page.view', {
      url: '',
      templateUrl: 'vnext/pages/browse/searchPage.html',
      controller: 'SearchPageCtrl',
      controllerAs: 'vm'
    }).state('vnext.content.browse.page.channel', {
      url: '/channel',
      templateUrl: 'vnext/pages/browse/channel.html',
      controller: 'BrowseChannelCtrl',
      controllerAs: 'vm',
      params: {
        channel: { value: undefined },
        pageTag: { value: undefined }
      }
    });
  }]);
})();